import React from "react";
import { Link } from "react-router-dom";

const base = "https://www.givevolunteers.org/";

const HelpfulLinks = () => (
  <div>
    <h4 className="h1-style muted">Helpful Links</h4>
    <ul>
      <li>
        <Link to="/portal-home#top" className="small-link">My Trips</Link>
      </li>
      {/* TODO: Fix these broken links :)
      <li>
        <Link to="/portal-home#add-ons" className="small-link">Extend Your Trip</Link>
      </li> */}
      <li>
        <Link to="/trip-selection" className="small-link">Add Another Trip</Link>
      </li>
      <li>
        <Link to="/profile#past-trips" className="small-link">Trip History</Link>
      </li>
      {/* <li>
        <Link to="/portal-home#invite-friends" className="small-link">Invite Friends</Link>
      </li> */}
      <li>
        <a
          href={`${base}get-inspired/volunteer-reviews/`}
          rel="noopener noreferrer"
          target="_blank"
          className="small-link"
        >
          Past Volunteers Reviews
        </a>
      </li>
      <li>
        <a
          href={`${base}get-inspired/videos/`}
          rel="noopener noreferrer"
          target="_blank"
          className="small-link"
        >
          Videos
        </a>
      </li>
      <li>
        <a
          href="https://givethreads.org"
          rel="noopener noreferrer"
          target="_blank"
          className="small-link"
        >
          GIVE Threads
        </a>
      </li>
      <li>
        <a
          href="https://www.givevolunteers.org/contact/"
          rel="noopener noreferrer"
          target="_blank"
          className="small-link"
        >
          Contact Us
        </a>
      </li>
    </ul>
  </div>
);

export default HelpfulLinks;
